import { render } from "./Detalhar.vue?vue&type=template&id=20eeabf2"
import script from "./Detalhar.vue?vue&type=script&lang=js"
export * from "./Detalhar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__